import Country from '~/Api/Country/Country';

export enum ErrorCode {
	RequiredProductSettingsMissingErrorCode = 'czech-max-price-calculation-required-product-settings-is-missing',
	IllegalPriceTypeSelectedErrorCode = 'czech-max-price-calculation-illegal-price-type-selected',
	ReferenceCountryProductMissingErrorCode = 'czech-max-price-calculation-requires-at-least-one-reference-country-product',
	OnlyOneProductPerCountryErrorCode = 'czech-max-price-calculation-requires-at-most-one-product-for-each-country',
	RequiresReferenceSettingsErrorCode = 'czech-max-price-calculation-requires-reference-settings',
	MissingThreeReferenceCountryProductsErrorCode = 'czech-max-price-calculation-requires-at-least-three-reference-country-products',
}

export class Error {
	code: ErrorCode;

	productId: string | null;

	duplicateCountries: Country[];

	constructor(code: ErrorCode, productId: string | null, duplicateCountries: Country[]) {
		this.code = code;
		this.productId = productId;
		this.duplicateCountries = duplicateCountries;
	}
}
